import { payerInvitationRoutes } from 'lib/navigation/helpers/getPayerSignUpPath/getPayerSignUpPath'
import { isAccountingFirm } from 'lib/helpers/isAccountingFirm/isAccountingFirm'
import { BusinessTypeEnum } from 'gql/types'

interface IGetOnboardingProgressValueParams {
  pathname: string
  businessType?: BusinessTypeEnum
}

export const getOnboardingProgressValue = ({
  pathname,
  businessType = BusinessTypeEnum.PAYER,
}: IGetOnboardingProgressValueParams) => {
  const maxProgress = 90
  const defaultSteps = [
    payerInvitationRoutes.product,
    payerInvitationRoutes.businessDetails,
    payerInvitationRoutes.revenue,
    payerInvitationRoutes.createAccount,
    '/verify-email',
    ['/free-trial', '/select-plan'],
  ]
  const stepsForAccountingFirm = [
    payerInvitationRoutes.product,
    payerInvitationRoutes.businessDetails,
    payerInvitationRoutes.createAccount,
    '/verify-email',
  ]

  const steps = isAccountingFirm(businessType) ? stepsForAccountingFirm : defaultSteps

  const progressStep = Math.floor(maxProgress / steps.length)
  let currentStepIndex = -1

  for (let i = 0; i < steps.length; i++) {
    const step = steps[i]

    if (!step) {
      continue
    }

    if (Array.isArray(step)) {
      for (const subStep of step) {
        if (pathname.includes(subStep)) {
          currentStepIndex = i
          break
        }
      }
    } else if (pathname.includes(step)) {
      currentStepIndex = i
      break
    }
  }

  if (currentStepIndex === -1) {
    return { prev: 0, current: 0 }
  }

  const prev = progressStep * currentStepIndex
  const current = prev + progressStep

  return { prev, current }
}
